import React, { useState, useEffect, useCallback } from 'react';
import { ActivityItem } from '@/apiSdk/api.type';
import { useOfficialStore } from '$/store/useOfficialStore';
import { useCommonStore } from '@/store/useCommonStore';
import { navigate } from '@/common/agents';
import style from './index.module.scss';

const INTERVAL = 3000;

export default function TopAlert({ activityList }: { activityList: ActivityItem[]; }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());
  const toLogin = useOfficialStore((state) => state.toLogin);
  const initUserInfo = useCommonStore((state) => state.initUserInfo);

  const next = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % activityList.length);
  }, [activityList.length]);

  useEffect(() => {
    if (activityList.length <= 1) return undefined;
    const timer = setInterval(next, INTERVAL);
    return () => clearInterval(timer);
  }, [activityList.length, next]);

  const current = activityList[currentIndex];

  const handleClick = useCallback(async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const jumpToActivity = () => {
      navigate({
        mode: 'url',
        url: current.activity_link,
      });
    };

    if (!isUserLoggedIn) {
      try {
        await toLogin().then(() => {
          initUserInfo();
        });
        jumpToActivity();
      } catch (error) {
        console.log('Login failed or cancelled', error);
      }
      return;
    }

    jumpToActivity();
  }, [current.activity_link, isUserLoggedIn, toLogin, initUserInfo]);

  return (
    <div className={style.alert_bpx}>
      <span>{current.activity_name}</span>
      <a href={current.activity_link} onClick={handleClick}>{current.btn_name}</a>
    </div>
  );
}
